import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { doSetBackActionStatusQueue } from '@/stores/reduxData'
import type { BackActionMap } from '@/components/common/back-action/types'
import type { RootState } from '@/stores/store'

interface BackActionContainerProps {
  name: BackActionMap['name']
  children: React.ReactNode
}

export const BackActionContainer = ({ name, children }: BackActionContainerProps) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const pathname = useSelector((state: RootState) => state.reduxDataReducers.backActionMapData[name].pathname)

  useEffect(() => {
    if (router.pathname !== pathname) {
      return
    }

    dispatch(doSetBackActionStatusQueue({ name, status: 'active' }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.pathname])

  return <>{children}</>
}
